module.exports = __webpack_public_path__ + "static/media/LibertadMono-Bold.b6d6f078.woff";